import { cn } from '@/lib/utils';

interface CharCounterProps {
  value: string;
  max: number;
  /**
   * `always` — visible from the first keystroke (prose Textareas).
   * `near-limit` — hidden until 70% of the cap (prose Inputs, F072 policy:
   * keeps dense screens like the catalog from showing dozens of counters).
   */
  mode?: 'always' | 'near-limit';
  className?: string;
}

/**
 * F072 — shared `X/N` character counter for capped text fields. Visual
 * pattern inherited from the original EssenceStep inline counters
 * (`text-xs text-muted-foreground`, right-aligned); flips to the existing
 * warning token at ≥90% of the cap. No new design tokens.
 */
export function CharCounter({ value, max, mode = 'always', className }: CharCounterProps) {
  const length = value.length;
  if (mode === 'near-limit' && length < max * 0.7) return null;
  const warning = length >= max * 0.9;
  return (
    <div className={cn('flex justify-end', className)}>
      <span
        data-testid="char-counter"
        aria-live="polite"
        className={cn('text-xs', warning ? 'text-warning-foreground' : 'text-muted-foreground')}
      >
        {length}/{max}
      </span>
    </div>
  );
}
